import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface ClaimApiItem {
  _id: string;
  claim_number: string;
  policy_number: string;
  claimant_name: string;
  claimant_phone?: string;
  claimant_email?: string;
  claim_type: string;
  claim_amount: number;
  department_name?: string;
  due_date?: string;
  received_date?: string;
  custom_claim_id?: string;
  meta?: {
    status?: string;
    createdAt?: string;
    updatedAt?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ClaimsListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    claims?: ClaimApiItem[];
    count?: number;
  };
}

export const getClaims = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  'meta.status'?: 'active' | 'inactive';
}): Promise<ClaimsListResponse> => {
  return api.get<ClaimsListResponse>(API_ENDPOINTS.claims.list, { params });
};
